// Attach all the domDOM listeners for the sake of debugging
// verbosity is 1 by default, but 2 for extra verbosity - i.e. include very noisy events like "timeupdate"
module.exports = (video, verbosity) => {
  verbosity = verbosity || 1;
  video.addEventListener('abort', (e) => {
    console.log('abort: Fires when the loading of an audio/video is aborted', e);
  });

  video.addEventListener('canplay', (e) => {
    console.log('canplay: Fires when the browser can start playing the audio/video', e);
  });

  video.addEventListener('canplaythrough', (e) => {
    console.log(
      'canplaythrough: Fires when the browser can play through the audio/video without stopping for buffering',
      e
    );
  });

  video.addEventListener('durationchange', (e) => {
    console.log('durationchange: Fires when the duration of the audio/video is changed', e);
  });

  video.addEventListener('emptied', (e) => {
    console.log('emptied: Fires when the current playlist is empty', e);
  });

  video.addEventListener('ended', (e) => {
    console.log('ended: Fires when the current playlist is ended', e);
  });

  video.addEventListener('error', (e) => {
    console.log('error: Fires when an error occurred during the loading of an audio/video', e);
  });

  video.addEventListener('loadeddata', (e) => {
    console.log(
      'loadeddata: Fires when the browser has loaded the current frame of the audio/video',
      e
    );
  });

  video.addEventListener('loadedmetadata', (e) => {
    console.log(
      'loadedmetadata: Fires when the browser has loaded meta data for the audio/video',
      e
    );
  });

  video.addEventListener('loadstart', (e) => {
    console.log('loadstart: Fires when the browser starts looking for the audio/video', e);
  });

  video.addEventListener('pause', (e) => {
    console.log('pause: Fires when the audio/video has been paused', e);
  });

  video.addEventListener('play', (e) => {
    console.log('play: Fires when the audio/video has been started or is no longer paused', e);
  });

  video.addEventListener('playing', (e) => {
    console.log(
      'playing: Fires when the audio/video is playing after having been paused or stopped for buffering',
      e
    );
  });

  video.addEventListener('progress', (e) => {
    console.log('progress: Fires when the browser is downloading the audio/video', e);
  });

  video.addEventListener('ratechange', (e) => {
    console.log('ratechange: Fires when the playing speed of the audio/video is changed', e);
  });

  video.addEventListener('seeked', (e) => {
    console.log(
      'seeked: Fires when the user is finished moving/skipping to a new position in the audio/video',
      e
    );
  });

  video.addEventListener('seeking', (e) => {
    console.log(
      'seeking: Fires when the user starts moving/skipping to a new position in the audio/video',
      e
    );
  });

  video.addEventListener('stalled', (e) => {
    console.log(
      'stalled: Fires when the browser is trying to get media data, but data is not available',
      e
    );
  });

  video.addEventListener('suspend', (e) => {
    console.log('suspend: Fires when the browser is intentionally not getting media data', e);
  });

  video.addEventListener('volumechange', (e) => {
    console.log('volumechange: Fires when the volume has been changed', e);
  });

  video.addEventListener('waiting', (e) => {
    console.log('waiting: Fires when the video stops because it needs to buffer the next frame', e);
  });

  if (verbosity > 1) {
    video.addEventListener('timeupdate', (e) => {
      console.log('timeupdate: Fires when the current playback position has changed', e);
    });
  }
};
